var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGamesRoom = function SvgGamesRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.197 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.599 5.1v-1a2 2 0 0 1 2-2h1a1.5 1.5 0 0 0 1.5-1.5m-8 8.5v2m0 0v2m0-2h-2m2 0h2m6.75 1.75h.01m-2.51-3.5h.01M6.212 5.1h8.774a5 5 0 0 1 4.983 4.598l.618 7.66a3 3 0 0 1-2.99 3.242h-.144a3 3 0 0 1-2.684-1.658l-.894-1.79a1 1 0 0 0-.895-.552H8.218a1 1 0 0 0-.895.553l-.894 1.789A3 3 0 0 1 3.744 20.6H3.6a3 3 0 0 1-2.99-3.241l.618-7.66A5 5 0 0 1 6.212 5.1m9.637 8a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5m-2.5-4a.25.25 0 1 1 0 .5.25.25 0 0 1 0-.5"
  })));
};
export default SvgGamesRoom;